import { useRef } from "react"

import ScatterChart from "@/app/report/components/chart/ScatterChart"
import SectionContainer from "@/app/report/components/SectionContainer"
import SectionMenu from "@/app/report/components/SectionMenu"
import { ChartScatterData, SectionScatterChart } from "@/app/report/common/constructor"
import {
  DEFAULT_EXPORT_OPTIONS,
  REPORT_TYPE,
  VALUE_POSITION_TYPE,
} from "@/app/report/common/constants"
import { useTranslateMetricKey } from "@/hooks/metric/useTranslateKeyHook"
import { ExportChartRefType } from "@/app/report/common/type"

export default function ScatterSection({
  reportSection,
  loading,
}: {
  reportSection: SectionScatterChart
  loading: boolean
}) {
  // 각 차트별 ref를 배열로 관리
  const chartRefs = useRef<ExportChartRefType[]>([])

  // 차트별로 menuItems를 반환하는 함수
  const getMenuItems = (chartIndex: number) => [
    ...DEFAULT_EXPORT_OPTIONS.map((option) => ({
      ...option,
      func: () => {
        chartRefs.current[chartIndex]?.exportFile({
          exportType: option.value,
          magnification: 1.0,
          reportType: window.location.pathname.includes(REPORT_TYPE.DAILY)
            ? REPORT_TYPE.DAILY
            : REPORT_TYPE.TREND,
          decimalPoints: 1,
          chartAnnotation: VALUE_POSITION_TYPE.HIDE_VALUES,
        })
      },
    })),
  ]

  const translateKey = useTranslateMetricKey()

  return (
    <div className="ScatterChartCont">
      {reportSection?.charts.map((chart: ChartScatterData, index: number) => {
        // axisX.name은 이미 translateKey로 번역된 값이거나 metric.xxx 형태
        // metric.xxx 형태면 key를 추출해서 번역, 아니면 그대로 사용
        const axisXKey = chart.axisX.name?.includes("metric.")
          ? chart.axisX.name.split("metric.")[1]
          : null
        const axisYKey = chart.axisY.name?.includes("metric.")
          ? chart.axisY.name.split("metric.")[1]
          : null

        const newAxisX = axisXKey ? translateKey(axisXKey) : chart.axisX.name
        const newAxisY = axisYKey ? translateKey(axisYKey) : chart.axisY.name
        const sectionTitle = `${newAxisX} / ${newAxisY}`

        return (
          <SectionContainer
            key={index}
            title={sectionTitle}
            sectionMenu={
              reportSection?.charts[0].data.length ? (
                <SectionMenu menuItems={getMenuItems(index)} />
              ) : undefined
            }>
            <ScatterChart
              chartData={chart}
              loading={loading}
              ref={(el) => {
                if (chartRefs.current && el) {
                  chartRefs.current[index] = el
                }
              }}
            />
          </SectionContainer>
        )
      })}
    </div>
  )
}
